<template>

  <div class="ui icon input">
    <input type="text" placeholder="Pesquisar..." v-model="search" @input="onSearch">
    <i class="search icon"></i>
  </div>

</template>

<script>

  import debounce from "debounce"

  export default {
    
    name: "SearchInput",

    data() {
      return {
        search: "",
      }
    },

    props: {
      id: { type: String, required: true },
      saveState: { type: Boolean, default: true },
    },

    mounted() {
      this.loadFromStore()      
    },

    beforeDestroy() {      
      this.saveInStore()
    },

    methods: {      

      clear() {        
        this.search = ""
        this.$emit("onClear")
      },

      onSearch: debounce(function() {
        this.$emit("onSearch", this.search)
      }, 1000),

      saveInStore() {

        if (!this.saveState)
          return

        let inputs = this.$cloneObject(this.$store.state.pages.searchInputs)

        if (!inputs[this.id])
          inputs[this.id] = {}

        inputs[this.id].text = this.search
        
        this.$store.commit("pages/setSearchInputs", inputs)
      },

      loadFromStore() {

        if (!this.saveState)
          return

        let input = this.$store.state.pages.searchInputs[this.id]

        if (input)
          this.search = input.text
      },
    },
  }

</script>

